module.exports = __webpack_public_path__ + "img/ability-swiper1.c9fb49f4.png";